import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  private api = inject(ApiService);

  getStatus(): Observable<any> {
    return this.api.get('membership/status');
  }

  getDetails(): Observable<any> {
    return this.api.get('membership/details');
  }

  getAdminStatus(businessId: string): Observable<any> {
    // Necesitamos un endpoint en el backend para que el Admin vea la membresía de OTRO negocio
    return this.api.get(`membership/admin/status/${businessId}`);
  }

  getAdminFullDetails(businessId: string): Observable<any> {
    return this.api.get(`membership/admin/details/${businessId}`);
  }

  renew(data: { planType: string, billingCycle: string, amount: number, reference?: string }): Observable<any> {
    return this.api.post('membership/renew', data);
  }

  adminAssign(data: {
    businessId: string;
    planType: string;
    billingCycle?: string;
    startDate?: string | Date;
    endDate: string | Date;
    amountPaid: number;
    status?: string;
    paymentStatus?: string;
  }): Observable<any> {
    return this.api.post('membership/admin/assign', data);
  }

  adminList(): Observable<any[]> {
    return this.api.get<any[]>('membership/admin/list');
  }

  getPlans(): Observable<any[]> {
    return this.api.get<any[]>('membership/plans');
  }

  // ─── Admin Plans CRUD ───────────────────────────────────────────────────

  adminPlansList(): Observable<any[]> {
    return this.api.get<any[]>('membership/admin/plans');
  }

  createPlan(data: any): Observable<any> {
    return this.api.post('membership/admin/plans', data);
  }

  updatePlan(id: string, data: any): Observable<any> {
    return this.api.put(`membership/admin/plans/${id}`, data);
  }

  deletePlan(id: string): Observable<any> {
    return this.api.delete(`membership/admin/plans/${id}`);
  }

  // ─── Payment Requests ───────────────────────────────────────────────────

  createPaymentRequest(formData: FormData): Observable<any> {
    return this.api.post('membership/payment-requests', formData);
  }

  getMyPaymentRequests(): Observable<any[]> {
    return this.api.get<any[]>('membership/payment-requests');
  }

  getAllPaymentRequests(businessId?: string): Observable<any[]> {
    const params = businessId ? { businessId } : undefined;
    return this.api.get<any[]>('membership/payment-requests/sys/all', params);
  }

  approvePaymentRequest(id: string): Observable<any> {
    return this.api.put(`membership/payment-requests/sys/${id}/approve`, {});
  }

  rejectPaymentRequest(id: string, observation: string): Observable<any> {
    return this.api.put(`membership/payment-requests/sys/${id}/reject`, { observation });
  }

}
